export default __webpack_public_path__ + "static/media/iconos-07.b6307c9f.png";